import { createTheme } from '@one-thd/sui-atomic-components';

const SecondarySpringKhaki = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

SecondarySpringKhaki.palette['--sui-palette-background-primary'] = '238 226 215';

export { SecondarySpringKhaki };